import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
    updateCartItemsAction,
    UpdateCartItemsState,
} from '../../redux/slices/updateCartItemsSlice';

const useCartUpdate = () => {
    const state: UpdateCartItemsState = useAppSelector(
        (state) => state.updateCartItems
    );
    const dispatch = useAppDispatch();

    const updateCart = useCallback(() => {
        dispatch(updateCartItemsAction.setItemsUpdate());
    }, []);

    return { ...state, updateCart };
};

export default useCartUpdate;
